<template>
  <div>
    <v-card
      id="cardDashbord"
      class="mx-auto"
      outlined
    >
      <div class="card-header-dashbord">
        <v-row>
          <v-col
            cols="12"
            sm="10"
            md="10"
            lg="10"
            class="d-flex flex-wrap"
          >
            Quanto tenho em aberto no ano, por mês de vencimento?
          </v-col>
          <v-col
            cols="12"
            sm="2"
            md="2"
            lg="2"
            class="d-flex justify-end"
          >
            <v-tooltip top>
              <template
                v-slot:activator="{ on, attrs }"
              >
                <v-icon
                  id="iconInformationFatxMetaComercial4"
                  class="text-left"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-information-outline
                </v-icon>
              </template>
              <div
                v-html="textoMes"
              />
            </v-tooltip>
          </v-col>
        </v-row>
      </div>
      <v-card-actions>
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <div
              v-if="loading"
              id="carregaDados"
              class="text-center"
              :style="styleObject"
            >
              <v-icon
                light
                class="custom-loader"
                :style="styleObject"
              >
                mdi-cached
              </v-icon>
              Carregando Dados...
            </div>
            <div
              v-else-if="error"
              class="alert alert-danger"
            >
              {{ error }}
            </div>
            <div v-if="!text">
              <canvas
                id="myChart23"
                width="250"
                height="80"
              />
              <div
                v-if="exibirLegenda"
                id="legenda"
                class="text-center px-3"
              >
                <v-row
                  align="center"
                  class="ma-0"
                  no-gutters
                >
                  <v-col
                    md="6"
                    offset-md="3"
                  >
                    <v-row>
                      <div
                        v-for="status in colors"
                        :key="status.status"
                      >
                        <v-avatar
                          class="mr-1"
                          :color="status.cor"
                          size="12"
                        />
                        <span class="mr-3 font-weight-light">{{ status.status }}</span>
                      </div>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
            </div>
            <div
              v-else
            >
              {{ text }}
            </div>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </div>
</template>

<script>
  import Chart from 'chart.js'
  import ContasReceber from '../../../../services/contasreceber'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'DashboardMovimentacaoMesAMes',
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
    },

    data: () => ({
      colors: [],
      myChart: {},
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      styleObject: {
        color: localStorage.corPrimaria,
      },
      enableGrafico: true,
      text: null,
      empresa: [],
      selectClientes: [],
      datasets: [],
      primeiroDia: '',
      ultimoDia: '',
      montaGrafico: true,
      loading: false,
      exibirLegenda: false,
      error: null,
      textoMes: '',
      dynamicPaddingMesAMes: '',
    }),

    created () {
      eventEmit.$on('set-movimentacao-mes-a-mes', this.handleUpdateDados)

      this.updateDynamicPaddingMesAMes()

      window.addEventListener('resize', this.updateDynamicPaddingMesAMes)
    },

    beforeDestroy () {
      eventEmit.$off('set-movimentacao-mes-a-mes', this.handleUpdateDados)

      window.removeEventListener('resize', this.updateDynamicPaddingMesAMes)
    },

    methods: {
      updateDynamicPaddingMesAMes () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingMesAMes = 'padding-right: 100rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingMesAMes = 'padding-right: 55rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingMesAMes = 'padding-right: 11rem !important'
        } else if (window.innerWidth > 600 && window.innerWidth < 1000) {
          this.dynamicPaddingMesAMes = 'padding-right: 25rem !important'
        } else {
          this.dynamicPaddingMesAMes = 'padding-right: 48rem !important'
        }
      },

      handleUpdateDados (primeiroDia, ultimoDia, select, texto, selectClientes) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = ultimoDia
        this.empresa = select
        this.textoMes = texto
        this.selectClientes = selectClientes

        this.MontarGrafico()
      },

      async MontarGrafico () {
        this.loading = true
        this.exibirLegenda = false

        if (this.myChart.data) {
          this.datasets = []
          this.colors = []

          this.myChart.destroy()
        }

        await ContasReceber.showMovimentacaoMesAMes(this.primeiroDia, this.ultimoDia, this.empresa, localStorage.tokencontrato, this.selectClientes).then(resposta => {
          if (resposta.data.status) {
            for (var i = 0; i < resposta.data.dadosExibicao.length; i++) {
              const dados = {
                label: resposta.data.dadosExibicao[i].status,
                backgroundColor: resposta.data.dadosExibicao[i].cor,
                order: i + 1,
                data: resposta.data.dadosExibicao[i].valores,
                pointColor: resposta.data.dadosExibicao[i].cor,
              }

              const cores = {
                status: resposta.data.dadosExibicao[i].status,
                cor: resposta.data.dadosExibicao[i].cor,
              }

              this.datasets.push(dados)
              this.colors.push(cores)
            }

            // eslint-disable-next-line no-unused-vars
            const legenda = resposta.data.legenda

            const ctx = document.getElementById('myChart23').getContext('2d')

            this.myChart = new Chart(ctx, {
              type: 'horizontalBar',
              data: {
                labels: resposta.data.datas,
                datasets: this.datasets,
              },
              options: {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    ticks: {
                      min: 0,
                    },
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                  yAxes: [{
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                  }],
                },
                legend: {
                  display: false,
                },
                tooltips: {
                  usePointStyle: true,
                  callbacks: {
                    mode: 'label',
                    label: (tooltipItem, data) => {
                      if (tooltipItem.xLabel > 0) {
                        var type = data.datasets[tooltipItem.datasetIndex].label
                        var valor = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

                        return type + ': ' + valor
                      } else {
                        return null
                      }
                    },
                  },
                },
              },
            })
          } else if (resposta.data.msg === 'Não há dados para montar o gráfico de acompanhamento mensal') {
            this.text = resposta.data.mg

            this.error = this.text

            if (this.myChart.data) {
              this.datasets = []
              this.colors = []

              this.myChart.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false

          this.exibirLegenda = true
        })
      },
    },
  }
</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  @media only screen
  and (min-device-width : 320px)
  and (max-device-width : 480px) {

  }
</style>

<style lang="sass">
  #legenda
    margin: 1rem 0 0 0

</style>
